<template>
  <div class="container-fluid">
    <div id="layout-wrapper">
      <app-header-bar :user="$store.state.users.name" />
      <app-side-bar :boards="boardsData" />
      <router-view :boards="boardsData.data" :key="$route.fullPath" />
    </div>
  </div>
</template>
<script>
import AppSideBar from "@/components/AppSideBar/AppSideBar.vue";
import AppHeaderBar from "@/components/AppHeaderBar/AppHeaderBar.vue";
import { mapState, mapActions } from "vuex";
export default {
  components: {
    AppSideBar,
    AppHeaderBar
  },
  data() {
    return {
      boardsData: {}
    };
  },
  mounted() {
    const b = document.body;
    b.dataset.layout = "detached";
    b.dataset.topbar = "colored";
    this.getUserBoards();
  },
  methods: {
    ...mapState(["users"]),
    ...mapActions([
      "showMessage",
      "showLoader",
      "setLoaderTitle",
      "showBlockScreen"
    ]),
    async getUserBoards() {
      try {
        const response = await this.$AppCallApi("GET", "board-user");
        if (response.data) {
          this.boardsData = response.data.data;
          console.log('boards data', this.boardsData)
        }
      } catch (error) {
        console.log("error", error);
      }
    }
  }
};
</script>